export class GlobalAdminBrowseLogsRequest {
    StartDate: Date;
    EndDate: Date;
    AdminID?: number;
}
